import React, { Component } from 'react';

class AccountRegistrationConfirmation extends Component {
  render() {
    return (
      <div className="p-5 form-container" id="view-register-local-account-confirmation">
        <div className="text-center">
          <h1 className="h4 text-gray-900 mb-4">Ο λογαριασμός σου δημιουργήθηκε!</h1>
        </div>
        <p className="mb-4">Σου έστειλα ένα email στη διεύθυνση {this.props.email} με το σύνδεσμο (link)
          ενεργοποίησης. Πάνε στα email σου, βρες το email που σου έστειλα και κάνε click στο
          σύνδεσμο που θα βρεις στο email.</p>
        <p className="mb-4">Ο σύνδεσμος είναι ενεργός μόνο για 4 ώρες και δουλεύει μόνο για μια
          φορά. Αν δε βρίσκεις το email, κοίταξε μήπως κατά λάθος κατέληξε στο φάκελο με τα ανεπιθύμητα.</p>
      </div>
    );
  }
}

export default AccountRegistrationConfirmation;